module.exports = __webpack_public_path__ + "img/CAD.8451816e.png";